/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import CampaignModel from 'cio/models/campaign';

interface FormsFormsTableRowCampaignsPopoverArgs {
  campaigns: CampaignModel[];
}

export default class FormsFormsTableRowCampaignsPopover extends Component<FormsFormsTableRowCampaignsPopoverArgs> {
  @service auth!: AuthService;
}
